const controls = new WeakMap();
const positive = value => /^[1-9]\d*$/.test(String(value));
export const contextoMidiaHistorico = vm => JSON.stringify([vm.$route.fullPath, vm.$route.params.id,
  vm.atendimento.ID, vm.atendimento.TIPO, vm.atendimento.IMAGEM_NUVEM, vm.atendimento.DATA_EXCLUSAO,
  vm.atendimento.LIBERACAO?.ID_PACIENTE_LAUDO, vm.atendimento.LIBERACAO?.PDF_ASSINADO,
  vm.atendimento.ASSINATURA?.ID_ATENDIMENTO, vm.atendimento.ASSINATURA?.ASSINADO,
  vm.atendimento.IMAGENS?.map(row => [row.ID, row.IMAGEM_NUVEM, row.DATA_EXCLUSAO])]);

export async function consultarPdfHistorico(api, jwt, { tipo, id, signal }) {
  if(!jwt.getToken() || !positive(id) || !["laudo", "ficha"].includes(tipo)) {
    throw new Error("Não foi possível consultar o PDF. Confira a sessão e o documento.");
  }
  api.setHeader();
  const { data } = await api.postOnce("atendimentos/access/" + (tipo === "laudo" ? "downloadLaudoPDF" : "downloadFichaPDF"),
    tipo === "laudo" ? { ID_PACIENTE_LAUDO: id } : { ID_ATENDIMENTO: id }, { signal, timeout: 120000 });
  if(typeof data?.ARQUIVO !== "string" || !data.ARQUIVO.trim()) { throw new Error("O PDF não está disponível."); }
  return data.ARQUIVO;
}

export async function lerPdfHistorico(arquivo, signal) {
  const response = await fetch(arquivo, { signal });
  if(!response.ok) { throw new Error("Não foi possível baixar o PDF."); }
  const blob = await response.blob();
  const header = await blob.slice(0, 5).text();
  const end = await blob.slice(Math.max(0, blob.size - 2048)).text();
  if(header !== "%PDF-" || !end.includes("%%EOF")) { throw new Error("O arquivo recebido não é um PDF completo."); }
  return blob;
}

export function midiasHistorico(vm) {
  if(controls.has(vm)) { return controls.get(vm); }
  let timer = null, download = null, closed = false, generation = 0;
  const valid = req => !closed && req.generation === generation && req.context === contextoMidiaHistorico(vm);
  const capture = () => ({ context: contextoMidiaHistorico(vm), generation });
  const belongs = row => row && (!row.ID_PACIENTE || String(row.ID_PACIENTE) === String(vm.$route.params.id)) &&
    [vm.atendimento, ...(vm.atendimento.IMAGENS || [])].some(item => String(item.ID) === String(row.ID) && item.TIPO === row.TIPO);
  const warn = text => vm.$swal({ icon: "warning", title: "Atenção!", text });
  function cancelClick() { clearTimeout(timer); timer = null; }
  function images(row, external, index = -1) {
    if(closed || !belongs(row)) { return false; }
    const group = index < 0 && row.IMAGENS?.length;
    const rows = group ? row.IMAGENS : [row];
    let warning = "", opened = false;
    const req = capture(), openings = [];
    rows.forEach((item, i) => {
      if(!belongs(item)) { return; }
      if(item.DATA_EXCLUSAO) { warning = "Uma ou mais imagens foram excluídas e não foram abertas."; return; }
      // Preserva o visualizador DICOM legado dos cartões nesta revisão de navegação.
      if(!external && item.TIPO_IMAGEM === "D" && vm.$options.name === "AtendimentoItem") {
        window.open("http://orthanc3.sp1.br.saveincloud.net.br/osimis-viewer/app/index.html?study=a024ac92-6ad233c2-399a1f35-50f121fd-51d2928a");
        opened = true; return;
      }
      if(!item.IMAGEM_NUVEM) { warning = "Uma ou mais imagens não estão disponíveis."; return; }
      if(external) {
        const tab = window.open(vm.backendURL + "pacientesImagensAccess/acessar/" + item.IMAGEM_NUVEM,
          "historico-imagem-" + vm.$route.params.id + "-" + item.ID);
        if(!tab || tab.closed) { warning = "O navegador bloqueou a abertura de uma ou mais imagens. Permita pop-ups para este site."; }
        else { opened = true; }
      } else {
        const ref = vm.$refs[group ? `modalImg-${i}` : index >= 0 ? `modalImg-${index}` : "modalImg"];
        const modal = Array.isArray(ref) ? ref[0] : ref;
        if(modal?.abrirModal) { openings.push(Promise.resolve(modal.abrirModal())); opened = true; }
        else { warning = "Não foi possível abrir a imagem. Tente novamente."; }
      }
    });
    if(warning) { warn(warning); }
    if(openings.length) {
      return Promise.all(openings).then(() => opened).catch(() => {
        if(valid(req)) { warn("Não foi possível abrir a imagem. Tente novamente."); } return false;
      });
    }
    return opened;
  }
  const c = {
    inserir(row, dados) {
      if(closed || !belongs(row) || row.DATA_EXCLUSAO || row.TIPO_IMAGEM !== "I" || !row.IMAGEM_NUVEM) { return false; }
      const image = vm.backendURL + "pacientesImagensAccess/acessar/" + row.IMAGEM_NUVEM;
      if(dados?.image !== image) { return false; }
      const req = capture(), id = String(row.ID), token = row.IMAGEM_NUVEM;
      const origemVigente = () => valid(req) && [vm.atendimento, ...(vm.atendimento.IMAGENS || [])].some(item =>
        String(item.ID) === id && item.IMAGEM_NUVEM === token && !item.DATA_EXCLUSAO);
      vm.$emit("inserirImagemLaudo", { contrato: "IMAGEM_HISTORICO_V1", image, ID_PACIENTE_IMAGEM: row.ID,
        ID_PACIENTE: vm.$route.params.id, ROTA: vm.$route.fullPath, origemVigente });
      return true;
    },
    abrir(row, editar = false, index = -1) {
      cancelClick();
      if(closed || !belongs(row)) { return false; }
      if(row.TIPO === "IMAGEM") { return images(row, false, index); }
      if(["DOCUMENTO", "RECEITUARIO"].includes(row.TIPO)) { return vm.abrirTextoHistorico(row, editar); }
      if(row.TIPO === "DETALHE" && editar) { return vm.abrirFichaDados(true); }
      vm.$emit("abrirAtendimento", row);
      if(vm.$options.name === "AtendimentoItem") { vm.emitter.emit("inicializarAtendimentoInfoTiss"); }
      return true;
    },
    externo(row) { cancelClick(); return images(row, true); },
    clique(event, row, double = false, lateral = false) {
      if(event?.target?.closest(".detalhes-actions, .dropdown-menu, .dropdown-item, button, a, [data-no-open]")) { return; }
      if(row.TIPO !== "IMAGEM" && event?.detail > 1) { return; }
      cancelClick();
      if(closed || !belongs(row)) { return; }
      const req = capture();
      const run = async () => {
        timer = null;
        if(!valid(req)) { return; }
        try {
          const external = row.TIPO === "IMAGEM" && (double !== (vm.inverteCliqueAbrirImagem == "1"));
          if(external) { images(row, true); } else { await c.abrir(row); }
          if(lateral && valid(req) && !["IMAGEM", "DOCUMENTO", "RECEITUARIO"].includes(row.TIPO)) {
            await vm.$nextTick();
            if(!valid(req)) { return; }
            const el = document.getElementById("atendimentoItemLateral");
            if(el && window.bootstrap?.Offcanvas) { window.bootstrap.Offcanvas.getOrCreateInstance(el).show(); }
          }
        } catch(error) { if(valid(req)) { warn("Não foi possível abrir este item. Tente novamente."); } }
      };
      // Somente imagens precisam aguardar a distinção entre clique e duplo clique.
      if(!double && row.TIPO === "IMAGEM") { timer = setTimeout(run, 250); }
      else if(!double || row.TIPO === "IMAGEM") { return run(); }
    },
    baixar(row) {
      if(closed || !belongs(row)) { return Promise.resolve(false); }
      if(download) { return download.promise; }
      const laudo = String(row.LIBERACAO?.PDF_ASSINADO) === "1" || row.LIBERACAO?.PDF_ASSINADO === true;
      const ficha = String(row.ASSINATURA?.ASSINADO) === "1" || row.ASSINATURA?.ASSINADO === true;
      const tipo = laudo ? "laudo" : "ficha", id = laudo ? row.LIBERACAO.ID_PACIENTE_LAUDO : row.ASSINATURA?.ID_ATENDIMENTO;
      if((!laudo && !ficha) || !positive(id)) { warn("Não há PDF assinado disponível para este item."); return Promise.resolve(false); }
      const req = { ...capture(), controller: new AbortController() };
      download = req; vm.baixandoPdfHistorico = true;
      const timeout = setTimeout(() => req.controller.abort(), 120000);
      req.promise = Promise.resolve().then(async () => {
        try {
          const arquivo = await vm.consultarPdfHistorico({ tipo, id, signal: req.controller.signal });
          if(!valid(req) || req.controller.signal.aborted) { return false; }
          const blob = await lerPdfHistorico(arquivo, req.controller.signal);
          if(!valid(req) || req.controller.signal.aborted) { return false; }
          const url = URL.createObjectURL(blob), a = document.createElement("a");
          try {
            a.href = url; a.download = `${tipo}-${id}.pdf`; a.style.display = "none";
            document.body.appendChild(a); a.click();
          } finally {
            a.remove();
            // O navegador deve consumir a URL antes da liberação do Blob.
            setTimeout(() => URL.revokeObjectURL(url), 1000);
          }
          return true;
        } catch(error) {
          if(valid(req)) { await warn("Não foi possível baixar o PDF assinado. O arquivo pode estar indisponível ou a conexão foi interrompida. Tente novamente."); }
          return false;
        } finally {
          clearTimeout(timeout);
          if(download === req) { download = null; vm.baixandoPdfHistorico = false; }
        }
      });
      return req.promise;
    },
    invalidar() { generation++; cancelClick(); download?.controller.abort(); download = null; vm.baixandoPdfHistorico = false; },
    destruir() { c.invalidar(); closed = true; }
  };
  controls.set(vm, c); return c;
}
